import type { MessageInstance } from "antd/es/message/interface";

let messageInstance: MessageInstance | null = null;

export const setGlobalMessage = (instance: MessageInstance) => {
  messageInstance = instance;
};

export const globalMessage = {
  success: (msg: string) => messageInstance?.success(msg),
  error: (msg: string) => messageInstance?.error(msg),
  warning: (msg: string) => messageInstance?.warning(msg),
};
